import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Todos from './components/Todos';
import AddTodo from './components/AddTodo';
import About from './components/pages/About';
import axios from 'axios';
// import { v4 as uuidv4 } from "uuid";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Container from 'react-bootstrap/Container';
import { ITodo } from './interfaces/todo';

class App extends Component {
  state = {
    todos: [],
  };

  // Another lifecycle method like render
  componentDidMount() {
    axios
      .get(
        'https://k7b1sod0rd.execute-api.us-east-1.amazonaws.com/dev/todos?_limit=10'
      )
      .then((res) => this.setState({ todos: res.data }));
  }

  // Arrow function or need to bind.(this) to markComplete !!!!
  markComplete = (id: string) => {
    // Map through and toggle the state
    this.setState({
      todos: this.state.todos.map((todo: ITodo) => {
        if (todo.id === id) {
          todo.checked = !todo.checked;
        }
        return todo;
      }),
    });
  };

  // Delete Todo. Filter out the ids that are passed in using spread operator
  // Copy everything what is in there with spread op.
  delTodo = (id: string) => {
    axios
      .delete(
        `https://k7b1sod0rd.execute-api.us-east-1.amazonaws.com/dev/todos/${id}`
      )
      .then((res) =>
        this.setState({
          todos: [...this.state.todos.filter((todo: ITodo) => todo.id !== id)],
        })
      );
  };

  // Add Todo

  addTodo = (text: string) => {
    axios
      .post(
        'https://k7b1sod0rd.execute-api.us-east-1.amazonaws.com/dev/todos',
        {
          text,
          checked: false,
        }
      )
      .then((res) => this.setState({ todos: [...this.state.todos, res.data] }));
  };

  render() {
    return (
      <Router>
        <div className="App">
          <Container className="p-3">
            <Header />
            <Route
              exact // It moves to a specific folder straight away
              path="/"
              render={(props) => (
                <React.Fragment>
                  <AddTodo addTodo={this.addTodo} />
                  <Todos
                    todos={this.state.todos}
                    markComplete={this.markComplete}
                    delTodo={this.delTodo}
                  />
                </React.Fragment>
              )}
            />
            <Route path="/about" component={About} />
          </Container>
        </div>
      </Router>
    );
  }
}

export default App;
